import { GLOBAL_STORE } from "./actionType";

const defaultState = {
  loading: false,//正在加载
  globalLoading: false,//全局正在加载
  //首页加载
  visionLoading: false,
  infoLoading: false,
  reportLoading: false,
  historyLoading: false,
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GLOBAL_STORE:
      return { ...state, ...action.store };
    default:
      return state;
  }
};
export default Reducer;
